/**
 * 瓦片图层的样式
 */
export var Attributes = ['size', 'color', 'shape'];
var common = ['opacity', 'zIndex'];
var rasterLayer = ['mask', 'rampColors', 'domain', 'clampHigh', 'clampLow', 'pixelConstant', 'pixelConstantR', 'pixelConstantG', 'pixelConstantB', 'pixelConstantRGB'].concat(common);
var pointLayer = ['stroke', 'strokeWidth', 'strokeOpacity', 'color', 'shape', 'size'].concat(common);
var lineLayer = ['stroke', 'strokeWidth', 'strokeOpacity', 'color', 'shape', 'size'].concat(common);
var polygonLayer = ['color', 'shape'].concat(common);
export var styles = {
  'PointLayer': pointLayer,
  'LineLayer': lineLayer,
  'PolygonLayer': polygonLayer,
  'RasterLayer': rasterLayer,
  'MaskLayer': [],
  'TileDebugLayer': []
};